import { Field, FieldProps, useFormikContext } from 'formik';
import { Button, Col, Input, Label, Modal, Row } from 'reactstrap';
import ErrorTooltip from './ErrorTooltip';

const FuelAdjustmentPopup = ({
    state,
    setState,
    tog_backdrop,
    target,
    fuelBatch,
}: any) => {
    const { values, errors, handleBlur, touched, handleChange, setFieldValue, initialValues, }:
        { values: any, errors: any, handleChange: any, handleBlur: any, touched: any, setFieldValue: any, initialValues: any } = useFormikContext<any>();

    const showToolTip = () => {
        if (
            errors && touched &&
            errors?.fuelConsumptionBatch && touched?.fuelConsumptionBatch &&
            (errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity || errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason) && (touched?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity || touched?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason)
        ) {
            return true;
        }
        return false;
    }
    return (
        <Modal
            size='md'
            isOpen={state}
            toggle={() => {
                tog_backdrop();
            }}
            backdrop={"static"}
            id={target}
            key={`${state}_${fuelBatch}`}
        >
            <div className="modal-header p-2">
                <h5 className="modal-title" id="staticBackdropLabel">
                    Fuel adjustment
                </h5>
                <button
                    onClick={() => {
                        setState(false);
                        if (errors?.fuelConsumptionBatch?.[fuelBatch]?.adjustment_quantity || errors?.fuelConsumptionBatch?.[fuelBatch]?.adjustment_reason) {
                            if (values?.fuelConsumptionBatch[fuelBatch]?.id) {
                                setFieldValue(`fuelConsumptionBatch.${fuelBatch}.adjustment_quantity`,
                                    initialValues?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity);
                                setFieldValue(`fuelConsumptionBatch.${fuelBatch}.adjustment_reason`,
                                    initialValues?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason);
                            } else {
                                setFieldValue(`fuelConsumptionBatch.${fuelBatch}.adjustment_quantity`, 0);
                                setFieldValue(`fuelConsumptionBatch.${fuelBatch}.adjustment_reason`, null);
                            }
                        }
                    }}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <Row className='mb-2'>
                    <Col lg={12}>
                        <p className='mb-0'>
                            * Input a positive number to increase the ROB.<br />
                            * Input a negative number to reduce the ROB.<br />
                            * <strong>If there is no change, enter zero.</strong>
                        </p><br />
                        <Label className='mb-0 mt-2'>Adjustment quantity</Label>
                        <Field name={`fuelConsumptionBatch.${fuelBatch}.adjustment_quantity`}>
                            {({ field }: FieldProps) => (
                                <div className="input-group">
                                    <Input
                                        autoComplete='off'
                                        onFocus={(e) => e.target.select()}
                                        type="text"
                                        name={field.name}
                                        id={`quantity_${fuelBatch}`}
                                        className="form-control max-width-7"
                                        onChange={(e: any) => handleChange(e)}
                                        onBlur={(e: any) => {
                                            handleChange(e);
                                            handleBlur(e);
                                        }}
                                        defaultValue={values?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity}
                                        autoFocus={true}
                                    />
                                    <div className="input-group-text">mt</div>
                                </div>
                            )}
                        </Field>
                        {showToolTip() &&
                            errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity &&
                            touched?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity &&
                            document.getElementById(`reason_${fuelBatch}`) !== null && state &&
                            <ErrorTooltip
                                target={`quantity_${fuelBatch}`}
                                message={errors && errors?.fuelConsumptionBatch && errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity}
                                open={
                                    (errors && errors?.fuelConsumptionBatch && errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity && state && fuelBatch !== null) ?
                                        true : false
                                }
                            />
                        }
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col lg={12}>
                        <Label className='mb-0'>Reason for adjustment</Label>
                        <Field name={`fuelConsumptionBatch.${fuelBatch}.adjustment_reason`}>
                            {({ field }: FieldProps) => (
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    type='textarea'
                                    name={field.name}
                                    id={`reason_${fuelBatch}`}
                                    className='form-control'
                                    onChange={(e: any) => handleChange(e)}
                                    onBlur={(e: any) => {
                                        handleChange(e);
                                        handleBlur(e);
                                    }}
                                    defaultValue={values?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason}
                                />
                            )}
                        </Field>
                        {showToolTip() &&
                            errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason &&
                            document.getElementById(`reason_${fuelBatch}`) !== null && state &&
                            <ErrorTooltip
                                target={`reason_${fuelBatch}`}
                                message={errors && errors?.fuelConsumptionBatch && errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason}
                                open={
                                    (errors && errors?.fuelConsumptionBatch && errors?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason && state && fuelBatch !== null) ?
                                        true : false
                                }
                            />
                        }
                    </Col>
                </Row>
                <Row>
                    <Col lg={2}>
                        <Button
                            type='button'
                            className='btn'
                            color='primary'
                            onClick={() => {
                                tog_backdrop();
                                if (values?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity === 0 || values?.fuelConsumptionBatch[fuelBatch]?.adjustment_quantity === '0') {
                                    setFieldValue(`fuelConsumptionBatch.${fuelBatch}.adjustment_reason`, null);
                                }
                            }}
                            disabled={showToolTip() || (
                                values?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason === null ||
                                values?.fuelConsumptionBatch[fuelBatch]?.adjustment_reason === '')}
                        >
                            Save
                        </Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    )
}

export default FuelAdjustmentPopup